module.exports = __webpack_public_path__ + "static/media/paso-2.c902e835.png";